import {Dispatch} from 'redux';
import {ErrorDto} from '../../../models/dtos/error.dto';
import {Errors} from '../../../utilities/errors';
import {UPLOAD_START, UPLOAD_SUCCESS, UPLOAD_FAIL, UPLOAD_RESET} from './constants';
import {UploadStartAction, UploadSuccessAction, UploadFailAction, UploadResetAction} from './types';
import {uploadRequest} from './repository';
import {UploadRequest} from '../../../models/requests/upload.request';
import {UploadDto} from '../../../models/dtos/upload.dto';

const uploadStartAction = (): UploadStartAction => {
  return {
    type: UPLOAD_START,
  };
};
const uploadSuccessAction = (payload: UploadDto): UploadSuccessAction => {
  return {
    type: UPLOAD_SUCCESS,
    payload: payload,
  };
};
const uploadFailAction = (error: ErrorDto): UploadFailAction => {
  return {
    type: UPLOAD_FAIL,
    error: error,
  };
};
const uploadResetAction = (): UploadResetAction => {
  return {
    type: UPLOAD_RESET,
  };
};

export const upload = (request: UploadRequest) => async (dispatch: Dispatch) => {
  try {
    dispatch(uploadStartAction());
    const response = await uploadRequest(request);
    dispatch(uploadSuccessAction(response));
  } catch (error) {
    dispatch(uploadFailAction(Errors.getErrorDtoFromApiError(error)));
  }
};

export const uploadReset = () => (dispatch: Dispatch) => {
  dispatch(uploadResetAction());
};
